<template>
	<v-app>
		<v-app-bar color="#003366" absolute clipped-left flat app>
			<v-app-bar-nav-icon class="hidden-sm-and-up"></v-app-bar-nav-icon>

			<img :src="baseLocation + '/resource/image/v-unite-logo.png'" style="height: 50px" @click="$store.commit('debug')" />

			<v-spacer></v-spacer>

			<v-menu left bottom offset-y rounded="b-xl">
				<template v-slot:activator="{ on, attrs }">
					<v-btn text v-bind="attrs" v-on="on">
						<v-icon color="rgba(255, 255, 255)">mdi-account-circle</v-icon>
						<span class="mx-1" style="color: #fff; text-transform: none">{{ $store.state.principal.email }}</span>
					</v-btn>
				</template>

				<v-list>
					<v-list-item @click="showChangePassword = true" link>
						<v-list-item-icon>
							<v-icon>mdi-lock-reset</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>Change password</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item @click="logout" link>
						<v-list-item-icon>
							<v-icon>mdi-logout-variant</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>Log out</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>

		<v-main>
			<v-container fluid>
				<router-view></router-view>
			</v-container>
		</v-main>

		<v-navigation-drawer
			app
			v-model="drawer"
			:mini-variant.sync="mini"
			color="primary"
			clipped
			absolute
			height="100%"
			:permanent="$vuetify.breakpoint.mdAndUp"
			dark
			style="z-index: 2"
		>
			<v-list>
				<v-list-item :to="'/administrator/tenant'" link>
					<v-list-item-icon>
						<v-icon>mdi-account-group</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Tenant</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/plan/tenant'" link>
					<v-list-item-icon>
						<v-icon>mdi-notebook-edit-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Tenant Plan</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/room/library'" link>
					<v-list-item-icon>
						<v-icon>mdi-home-edit</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Room Library</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/booth/background/library'" link>
					<v-list-item-icon>
						<v-icon>mdi-home-edit</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Booth Background Library</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/booth/design/library'" link>
					<v-list-item-icon>
						<v-icon>mdi-home-edit</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Booth Design Library</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/leaderboard/library'" link>
					<v-list-item-icon>
						<v-icon>mdi-home-edit</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Leaderboard Library</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/frame/library'" link>
					<v-list-item-icon>
						<v-icon>mdi-image-frame</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Frame Library</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/transition/library'" link>
					<v-list-item-icon>
						<v-icon>mdi-home-edit</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Transition Library</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/button/library'" link>
					<v-list-item-icon>
						<v-icon>mdi-gesture-tap-button</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Button Library</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/emailtemplate'" link>
					<v-list-item-icon>
						<v-icon>mdi-email-edit-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>E-mail Template</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/TrainingAndTutorial'" link>
					<v-list-item-icon>
						<v-icon>mdi-message-bookmark</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Training & Tutorial</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/globalCalendar'" link>
					<v-list-item-icon>
						<v-icon>mdi-calendar</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Global Calendar</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/administrator/administratorEmail'" link>
					<v-list-item-icon>
						<v-icon>mdi-email-variant</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Administrator Email</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					@click="dialogUniversalPassword"
					link
				>
					<v-list-item-icon style="color: white !important">
						<v-icon>mdi-lock</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Universal Password</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-dialog v-model="showDialogUniversalPassword" max-width="500" persistent>
			<v-card>
				<v-card-title>Universal Password</v-card-title>

				<v-form ref="form" v-model="valid" class="px-5">
					<v-alert v-model="alertUniversalPassword.show" :type="alertUniversalPassword.type" dismissible>{{ alertUniversalPassword.message }}</v-alert>
					<v-text-field
						v-model="uPassword"
						:rules="[(v) => !!v || 'Please specify a password']"
						label="Password"
						:type="passwordFieldType"
						:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="switchVisibility"
						dense
						rounded
						filled
						required
					></v-text-field>
					<div style="font-size:12px;margin-left:13px">
						<span>Use this password to login to the tenant portal and also experience portal</span>
					</div>
					<br />
				</v-form>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="closeDialogUniversalPassword">Cancel</v-btn>
					<v-btn :disabled="!valid" color="primary" @click="saveUniversalPassword">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showChangePassword" max-width="500">
			<v-card>
				<v-card-title>Change password</v-card-title>

				<v-form ref="form" v-model="valid" class="px-5">
					<v-alert v-model="alert.show" :type="alert.type" dismissible>{{ alert.message }}</v-alert>
					<v-text-field
						v-model="password"
						:rules="[(v) => !!v || 'Please specify a password']"
						type="password"
						label="Password"
						dense
						rounded
						filled
						required
					></v-text-field>
					<v-text-field
						v-model="confirmPassword"
						:rules="[
							(v) => !!v || 'Please confirm your password',
							(v) => (v && v === password) || 'Password does not match confirm password',
						]"
						type="password"
						label="Confirm Password"
						dense
						rounded
						filled
						required
					></v-text-field>
				</v-form>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="showChangePassword = false">Cancel</v-btn>
					<v-btn :disabled="!valid" color="primary" @click="changePassword">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="$store.state.notification.show" width="500">
			<v-card style="padding: 20px">
				<!-- <div style="display: flex; justify-content: space-between">
					<h2 style="margin-bottom: 10px">Whoops! ({{ $store.state.notification.title }})</h2>
					<v-btn icon color="secondary" @click="closeNotification">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div> -->
				
				<div class="text-center mb-5">
					<h2 style="margin-bottom: 10px; font-size: larger;"
					>Something Went Wrong</h2>
				</div>


				<template v-if="$store.state.notification.content && $store.state.notification.content.type == 'NOTIFICATION'">
					<div class="text-center" style="color: #c42126; font-size: 14px" :key="index" v-for="(item, index) in $store.state.notification.content.fieldErrorList">
						{{ item }}
					</div>
					<div class="text-center" style="color: #ed5025; font-size: 14px" :key="index" v-for="(item, index) in $store.state.notification.content.errorList">
						{{ item }}
					</div>
					<div class="text-center" style="color: #e26026; font-size: 14px" :key="index" v-for="(item, index) in $store.state.notification.content.noticeList">
						{{ item }}
					</div>
				</template>
				<template v-else>
					<div class="text-center" style="color: #e26026; font-size: 14px">{{ $store.state.notification.content }}</div>
				</template>
				<div class="text-center mt-5 mr-10 ml-10">
					<p style="font-size: 10px; font-weight: bold;">If this issue persists please contact us through our email with a screenshot at <span 
					style="color:blue; text-decoration: underline;">support@v-unite.com</span></p>
				</div>
				<div style="text-align: center; margin-top: 20px">
					<v-btn color="#009ec1" @click="closeNotification">Close</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-overlay style="z-index: 999;" :value="$root.loader.value" opacity="0">
			<img :src="baseLocation + '/resource/image/loader.svg'" class="loader" />
		</v-overlay>
	</v-app>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			showChangePassword: false,
			valid: false,
			password: null,
			confirmPassword: null,
			alert: { show: false, message: "" },
			baseLocation: axios.defaults.baseURL,
			drawer: true,
			mini: false,
			uPassword: null,
			uId: null,
			showDialogUniversalPassword: false,
			alertUniversalPassword: { show: false, message: "" },
			passwordFieldType: "password",
		};
	},
	methods: {
		changePassword() {
			axios
				.post("/system/user/changepassword", {
					password: this.password,
					confirmPassword: this.confirmPassword,
				})
				.then(() => {
					[this.alert.type, this.alert.message, this.alert.show] = ["success", "Your password has been changed", true];
					this.$refs.form.reset();
				})
				.catch(() => {
					[this.alert.type, this.alert.message, this.alert.show] = ["error", "Change password failed", true];
				});
		},
		logout() {
			this.$store
				.dispatch("logout")
				.then(() => {
					this.$router.push("/administrator");
				})
				.catch(() => {});
		},
		closeNotification() {
			if (this.$store.state.notification.title === "Unauthorized") {
				this.$store.commit("hideNotification");
				this.$router.push("/administrator");
			} else {
				this.$store.commit("hideNotification");
			}
		},
		dialogUniversalPassword() {
			axios.post("/system/universalPassword/get", {}).then((response) => {
				if (response.data) {
					this.uId = response.data.id;
					this.uPassword = response.data.password;
				} else {
					this.uId = null;
				}
				this.showDialogUniversalPassword = true;
			});
		},
		saveUniversalPassword() {
			let url, entity, messageSucces, messageError;

			if (this.uId === null) {
				url = "/system/universalPassword/add";
				messageSucces = "Your password has been saved";
				messageError = "Save password failed";
				entity = {password:this.uPassword};
			} else {
				url = "/system/universalPassword/edit";
				messageSucces = "Your password has been changed";
				messageError = "Change password failed";
				entity = {id:this.uId, password:this.uPassword};
			}
			
			axios
				.post(url, {
					entity: entity,
				})
				.then(() => {
					[this.alertUniversalPassword.type, this.alertUniversalPassword.message, this.alertUniversalPassword.show] = ["success", messageSucces, true];
				})
				.catch(() => {
					[this.alertUniversalPassword.type, this.alertUniversalPassword.message, this.alertUniversalPassword.show] = ["error", messageError, true];
				});
			
		},
		switchVisibility() {
			this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
		},
		closeDialogUniversalPassword() {
			this.showDialogUniversalPassword = false;
			this.alertUniversalPassword = { show: false, message: "" };
		}
	},
};
</script>